import { signInWithEmailAndPassword } from "firebase/auth";
import { FormEvent, useCallback, useState } from "react";
import { toast } from "react-toastify";
import { auth } from "../firebase";
import { Input } from "../components/Input/Input";
import { Button } from "../components/Button/Button";

export const Login = () => {
  const [credentials, setCredentials] = useState<{
    mail: string;
    password: string;
  }>({ mail: "", password: "" });

  /**
   * Helper method to handle the login
   */
  const handleLogin = useCallback(
    (evt: FormEvent): void => {
      evt.preventDefault();
      signInWithEmailAndPassword(
        auth,
        credentials.mail,
        credentials.password
      ).then((resp) => {
        if (!resp)
          toast("Fehler beim Login", {
            type: "error",
          });
      });
    },
    [credentials.mail, credentials.password]
  );

  return (
    <form onSubmit={(e) => handleLogin(e)} className="login-page">
      <div className="login-page__login-wrapper">
        <p className="login-page__login-wrapper__headline">
          DevDuck Component Library
        </p>
        <Input
          type="text"
          label="Mail"
          value={credentials.mail}
          onChange={(mail) => setCredentials({ ...credentials, mail })}
        />
        <Input
          type="password"
          label="Password"
          value={credentials.password}
          onChange={(password) => setCredentials({ ...credentials, password })}
        />
        <Button
          type="submit"
          label="Login"
          className="login-page__login-button"
        />
      </div>
    </form>
  );
};
